import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f601758"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Card" }
const _hoisted_2 = { class: "layout" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "btn-search" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "13",
    fill: "currentColor",
    class: "bi bi-search",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" })
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Select", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Paises", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Ciudades", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Puertos", -1))
const _hoisted_10 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col d-flex flex-column justify-content-center align-items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "PAISES")
], -1))
const _hoisted_15 = { class: "card overflow-scroll" }
const _hoisted_16 = { class: "table table-hover table-sm" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "País"),
    /*#__PURE__*/_createElementVNode("th", null, "Nombre"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Iso"),
    /*#__PURE__*/_createElementVNode("th", null, "Phone Code")
  ])
], -1))
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col d-flex flex-column justify-content-center align-items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "CIUDADES")
], -1))
const _hoisted_22 = { class: "card overflow-scroll" }
const _hoisted_23 = { class: "table table-hover table-sm" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Ciudad"),
    /*#__PURE__*/_createElementVNode("th", null, "Nombre"),
    /*#__PURE__*/_createElementVNode("th", null, "Pais")
  ])
], -1))
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col d-flex flex-column justify-content-center align-items-center" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "PUERTOS")
], -1))
const _hoisted_29 = { class: "card overflow-scroll" }
const _hoisted_30 = { class: "table table-hover table-sm" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Puerto"),
    /*#__PURE__*/_createElementVNode("th", null, "Nombre"),
    /*#__PURE__*/_createElementVNode("th", null, "Tipo"),
    /*#__PURE__*/_createElementVNode("th", null, "Pais"),
    /*#__PURE__*/_createElementVNode("th", null, "Ciudad")
  ])
], -1))

import { ref, onMounted, computed,Ref } from 'vue';
import axios from 'axios';
import { Paises, Ciudades, Puertos } from '@/interface/interfaces';
import { UrlGlobal } from '@/store/dominioGlobal';


export default /*#__PURE__*/_defineComponent({
  __name: 'PcP',
  setup(__props) {

const dUrl = UrlGlobal()
const search = ref('')
const options = ref('')
//-----------------------------------------------------------------
const paises = ref<Array<Paises>>([]);

const getPaises = () => {
    axios.get(dUrl.urlGlobal +'/api2/paises/')
        .then(response => {
            paises.value = response.data;
        })
        .catch(error => {
            console.error('Error fetching cargos:', error);
        });
};
//----------------------------------------------------------------

const ciudades = ref<Array<Ciudades>>([])
const getCiudades = (id_pais: any) => {
    axios.get(`${dUrl.urlGlobal}/api2/paises/ciudad?id_pais=${id_pais}`)
        .then(response => {
            ciudades.value = response.data;
        })
        .catch(error => {
            console.error('Error fetching ciudades:', error);
        });
};

//----------------------------------------------------------------
const puertos = ref<Array<Puertos>>([])
const getPuertos = (id_ciudad: any, id_pais: any) => {
    axios.get(`${dUrl.urlGlobal}/api2/paises/puertos?id_ciudad=${id_ciudad}&id_pais=${id_pais}`)
        .then(response => {
            puertos.value = response.data;
        })
        .catch(error => {
            console.error('Error fetching puertos:', error);
        });
};

//-----------------------------------------------------------------

// Filtrar los registros que coincidan con el valor de búsqueda en cualquiera de los campos segun la tabla------------------------------------------------
const filteredCarga1 = computed(() => {
    if (search.value === '') {
        // Si no hay nada en la búsqueda, retornar todos los registros
        return paises.value;
    } else if (options.value == 'Paises') {
        // Convertir el término de búsqueda a minúsculas para hacer la búsqueda insensible a mayúsculas
        const searchTerm = search.value.toLowerCase();
        // Filtrar los registros que coincidan con el valor de búsqueda en cualquiera de los campos
        return paises.value.filter(elm => {
            return (
                elm.pais?.toLowerCase().includes(searchTerm) ||
                elm.nombre?.toLowerCase().includes(searchTerm) ||
                elm.name?.toLowerCase().includes(searchTerm) ||
                elm.iso2?.toLowerCase().includes(searchTerm) ||
                elm.phone_code?.toLowerCase().includes(searchTerm)
            );
        });
    }else{
        return paises.value
    }
});

//----------------------------------------------------------------
const filteredCarga2 = computed(() => {
    if (search.value === '') {
        return ciudades.value;

    } else if (options.value == 'Ciudades') {
        const searchTerm = search.value.toLowerCase();

        return ciudades.value.filter(elm => {
            return (
                elm.ciudad?.toLowerCase().includes(searchTerm) ||
                elm.nombre?.toLowerCase().includes(searchTerm) 
            );
        });
    }else{
        return ciudades.value
    }
});

//----------------------------------------------------------------
const filteredCarga3 = computed(() => {
    if (search.value === '') {
        return puertos.value;
    } else if (options.value == 'Puertos') {
        const searchTerm = search.value.toLowerCase();
        return puertos.value.filter(elm => {
            return (
                elm.puerto?.toLowerCase().includes(searchTerm) ||
                elm.nombre?.toLowerCase().includes(searchTerm) ||
                elm.tipo?.toLowerCase().includes(searchTerm) ||
                elm.pais?.toLowerCase().includes(searchTerm) ||
                elm.ciudad?.toLowerCase().includes(searchTerm)
            );
        });
    }else{
        return puertos.value
    }
});
//-----------------------------------------------------------------------------------------------------------------------

onMounted(() => {
    getPaises();
    getCiudades("1");
    getPuertos("1", "1")
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("body", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "search",
              id: "search",
              placeholder: "Buscar",
              style: {"background-color":"transparent","border":"none","outline":"none","color":"white"},
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event))
            }, null, 512), [
              [_vModelText, search.value]
            ]),
            _withDirectives(_createElementVNode("select", {
              style: {"background-color":"transparent","border":"none","outline":"none","color":"black"},
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((options).value = $event))
            }, _hoisted_10, 512), [
              [_vModelSelect, options.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("table", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCarga1.value, (elm) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: elm.pais,
                        onClick: ($event: any) => (getCiudades(elm.pais))
                      }, [
                        _createElementVNode("td", null, _toDisplayString(elm.pais), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nombre), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.name), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.iso2), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.phone_code), 1)
                      ], 8, _hoisted_18))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("table", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCarga2.value, (elm) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: elm.ciudad,
                        onClick: ($event: any) => (getPuertos(elm.ciudad, elm.pais))
                      }, [
                        _createElementVNode("td", null, _toDisplayString(elm.ciudad), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nombre), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nombre_pais), 1)
                      ], 8, _hoisted_25))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("table", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCarga3.value, (elm) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: elm.puerto
                      }, [
                        _createElementVNode("td", null, _toDisplayString(elm.puerto), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nombre), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.tipo), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nombre_pais), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nombre_ciudad), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})